module.exports = __webpack_public_path__ + "static/black-future-88-green-ceda7bd20922a6f2ff3a77fb15ce3b84.png";